(function ($) {
  var $body = $('body'), $win = $(window), cusEl = customElements;
  if (!cusEl.get('cdz-mega-menu')) {
    cusEl.define('cdz-mega-menu', class CdzMegaMenu extends HTMLElement {
      options = {
        hBreakpoint: 768,
        touchText: "Go to <span class=\"cdz-text\">%1<\/span>",
        backText: "<span class=\"cdz-text\">%1<\/span>"
      }
      constructor() {
        super();
        if (this.isVerMenu()) this.prepareVerMenu();
        this.options = $.extend(this.options, this.dataset);
        this.element = $(this);
        this.resTimeout = false;
        this.addEvents();
        this.prepareHtml();
        this.element.removeClass('no-loaded');
      }
      isMobiMenu() {
        return (window.innerWidth < this.options.hBreakpoint) || this.element.parents('.cdz-tg-menu').length;
      }
      addEvents() {
        var self = this, t = false, align = (isSticky) => {
          if (t) clearTimeout(t);
          t = setTimeout(() => {
            isSticky ? self.alignDropdown('.js-align-drop-sticky') : self.alignDropdown('.js-align-drop');
          }, 100);
        };;
        $win.on('cdz_desktop', () => this.prepareDesk()).on('cdz_mobile', () => this.prepareMobi());
        document.addEventListener('shopify:block:select', () => {
          self.isMobiMenu() ? self.prepareMobi() : self.prepareDesk(); align($('header.stiky-active').length);
        });
        if (this.isHorMenu()) {
          var ovfT = false;
          $win.on('headerStateChanged ' + winWidthChangedEvent, (e, isSticky) => {
            align(isSticky);
            if (ovfT) clearTimeout(ovfT);
            ovfT = setTimeout(self.hideOverflowingItems.bind(self), (e.type == winWidthChangedEvent) ? 300 : 50);
          });
          this.element.on('menuHideOvf menuPageChanged', () => align($('header.stiky-active').length));
        } else {
          $win.on(winWidthChangedEvent, () => this.prepareMobi());
        }
      }
      prepareVerMenu() {
        if (typeof window.cdzVerMenuCopied == 'undefined') {
          window.cdzVerMenuCopied = true;
          if ($('[role="vmenu_content"]').length) {
            this.countVerMenu();
            $win.on(winWidthChangedEvent, () => setTimeout(() => this.countVerMenu, 100));
          }
        }
      }
      countVerMenu() {
        var action = ($('.cdz-menu-ver:visible').length == 1) ? 'addClass' : 'removeClass';
        $('[role="vmenu_title"]').parents('[role="vmenu_wrap"]').first()[action]('one-vmenu');
      }
      prepareHtml() {
        this.isMobiMenu() ? this.prepareMobi() : this.prepareDesk();
        this.alignDropdown('.js-align-drop');
        this.alignVerDropdown();
        this.addTouchLinks();
        if (this.isHorMenu()) {
          this.hideOverflowingItems();
          setTimeout(() => $win.trigger('cdzStickyHeight'), 100);
        } else {
          if (this.isTouchDevice()) this.prepareMobi();
        }
      }
      isHorMenu() {
        return this.dataset.type == '0';
      }
      isVerMenu() {
        return this.dataset.type == '1';
      }
      isRtl() {
        return $body.attr('dir') === 'rtl';
      }
      isFullMenu() {
        return this.element.hasClass('mn-full');
      }
      prepareMobi() {
        var self = this;
        if (this.resTimeout) clearTimeout(this.resTimeout);
        self.element.removeClass('no-loaded').addClass('cdz-m-menu').removeClass('cdz-d-menu').find('> .js-items > .mn-item > .mn-items').css({ left: '', right: '', top: '' });
      }
      prepareDesk() {
        if (this.resTimeout) clearTimeout(this.resTimeout);
        this.element.removeClass('cdz-m-menu').addClass('cdz-d-menu');
        if (this.isMobiMenu()) {
          this.prepareMobi();
        } else {
          this.element.addClass('no-loaded');
          this.resTimeout = setTimeout(() => {
            if (this.isHorMenu()) this.hideOverflowingItems();
            this.element.removeClass('no-loaded');
          }, 100);
        }
      }
      alignDropdown(alignSl) {
        if (this.isHorMenu()) {
          var $el = $(this), $alignCont = $el.parents(alignSl).first(), isFull = this.isFullMenu(), isRtl = this.isRtl();
          if ($alignCont.length === 0) $alignCont = $el.parent();
          var acWidth = $alignCont.outerWidth(), acLeft = $alignCont.offset().left, acPad = parseFloat($alignCont.css('padding-right')), acRight = acLeft + acWidth - acPad;
          $el.find('> .js-items > .mn-item > .mn-items').css({ left: '', right: '' }).each(function () {
            var $drop = $(this).css({ display: 'block', opacity: 0, visibility: 'hidden' }), $li = $drop.parent();
            if ((isFull || $li.hasClass('dd-full')) && (!$li.hasClass('cdz-tree-wrap'))) {
              if (isRtl) {
                $drop.css({ right: $drop.offset().left });
              } else {
                $drop.css({ left: -$drop.parent().offset().left });
              }
            } else {
              if (isRtl) {
                let dpLeft = $drop.offset().left, dt = acLeft - dpLeft;
                if (dt > 0) $drop.css({ right: -dt });
              } else {
                let dpWidth = $drop.outerWidth(), dpLeft = $drop.offset().left, dpRight = dpLeft + dpWidth,
                  dt = dpRight - acRight;
                if (dt > 0) $drop.css({ left: -dt });
              }
            }
            $drop.css({ display: '', opacity: '', visibility: '' });
          });
        }
      }
      alignVerDropdown() {
        if (!this.isHorMenu() && !this.isFullMenu() && (window.innerWidth >= 768)) {
          $('.js-items > .mn-item > .mn-items', this.element).each(function () {
            var $drop = $(this), $pr = $drop.parent(), align = () => {
              var drTop = $drop.offset().top, dpHeight = $drop.outerHeight(), wTop = $win.scrollTop(), wHeight = $win.innerHeight(),
                drBottom = drTop + dpHeight, wBottom = wTop + wHeight;
              $drop.css('top', Math.min(wBottom - drBottom, 0));
            };
            $pr.hover(align, () => { $drop.css('top', ''); });
            if ($drop.find('.slider-loaded')) { $pr.one('mouseover', () => setTimeout(align, 50));}
          });
        }
      }
      isTouchDevice() {
        return this.element.hasClass('cdz-m-menu') || matchMedia('(hover: none)').matches;
      }
      addTouchLinks() {
        var conf = this.options;
        $('li.mn-item.parent', this.element).each((i, el) => {
          var $li = $(el), $a = $li.children('a').first(), href = $a.attr('href'), $ul = $li.children('.mn-items').first(), $aClone = $a.clone(); $aClone.find('.mn-tag').remove();
          var aText = $aClone.text(); $aClone.remove();
          if ((href.indexOf('#') === -1) && (href.indexOf('javascript:') === -1)) {
            let tText = conf.touchText.replace('%1', aText), $tLi = $('<li class="mn-t-item">').prependTo($ul);
            $('<a class="mn-t-link">').attr('href', href).html(tText).appendTo($tLi);
          }
          var bText = conf.backText.replace('%1', aText), $backLi =  $('<li class="mn-b-item">').prependTo($ul);
          $('<a class="mn-b-link">').on('click', (e) => {
            e.preventDefault();
            $li.removeClass('active');
          }).html(bText).appendTo($backLi);
          $a.on('click', (e) => {
            if (this.isTouchDevice()) { e.preventDefault(); if (this.element.hasClass('cdz-m-menu')) $li.toggleClass('active').siblings().removeClass('active'); }
          });
        });
      }
      hideOverflowingItems() {
        var conf = this.options, $el = this.element.css('min-width', ''), $ul = $('.js-items', $el).first().css('display', ''),
        p2A = 'mn-p2-active';
        $('> .mn-p-two > .mn-item', $el).appendTo($ul); $el.removeClass(p2A);
        var $li = $('> .mn-item', $ul), $p2 = $('> .mn-p-two', $el).hide(), $pTg = $('> .mn-p-toggle', $el).addClass('hidden'), subtract = 2;
        if (!$p2.length) {
          $pTg = $('<div class="mn-p-toggle hidden">').appendTo($el);
          $p2 = $('<ul class="mn-p-two">').addClass($ul.attr('class')).hide().appendTo($el);
          $pTg.on('click', () => {
            var isP2 = $el.hasClass(p2A), $visible = isP2 ? $p2 : $ul, $hidden = isP2 ? $ul : $p2;
            $visible.fadeToggle(300, 'swing', () => {
              $hidden.fadeToggle(300, 'swing', () => { $hidden.css('display', ''); $el.trigger('menuPageChanged'); });
              $el.toggleClass(p2A);
            });
          });
        }
        var lisW = 0, liW, $pTgClone = $pTg.clone().css({position: 'absolute', opacity: 0}).insertAfter($pTg).removeClass('hidden'),
        pTgW = parseInt($pTgClone.outerWidth(true));
        $pTgClone.remove();
        var getOvfIndex = () => {
            var ovfId = -1, ulW = parseInt($ul.innerWidth());
            $li.each((i, li) => {
              liW = parseInt($(li).outerWidth(true));
              lisW += liW;
              if ((lisW + pTgW >= ulW)) {
                ovfId = i;
                if ((i == ($li.length - 1)) && (lisW <= ulW)) ovfId = -1;
                return false;
              }
            });
            return ovfId;
        }, ovfId = getOvfIndex();
        if ((ovfId > 0) && (window.innerWidth >= conf.hBreakpoint)) {
          $('> .mn-item:gt('+ (ovfId - 1) +')', $ul).appendTo($p2);
          $pTg.removeClass('hidden');
          $el.css('min-width', lisW - liW + pTgW + 2);
        }
        $el.trigger('menuHideOvf');
      }
    });
  }
  if (!cusEl.get('cdz-side-menu')) {
    cusEl.define('cdz-side-menu', class CdzSideMenu extends HTMLElement {
      constructor() {
        super();
        this.$mn = $('.cdz-menu', this);
        this.$sb = $('#cdz-side-menu');
        if (this.$mn.length && this.$sb.length) this.prepareHtml();
      }
      prepareHtml() {
        this.$sbWrap = this.$sb.parents('.cdz-sidebar');
        this.$mnWrap = $('#side-menu-wrap');
        this.$sb.parents('.cdz-sb-content').first().addClass('cdz-ver-mn-bar');
        if (!this.$mnWrap.length) {
          var side = this.$sbWrap.data('side');
          this.$mnWrap = $('<div class="aside-menu-wrap" id="side-menu-wrap">').addClass('smn-' + side).css('--side', side).appendTo(this.$sbWrap.parent());
        }
        this.$mn.addClass('mn-sb-org').appendTo(this.$mnWrap);
        this.$mnTmp = this.$mn.clone().addClass('mn-sb-tmp').appendTo(this.$sb);
        this.$mnTmp.find('.js-items > .mn-item').each((i, li) => {
          let $liTmp = $(li), $li = this.$mn.find(`.js-items > .mn-item:eq(${i})`);
          $liTmp.on('mouseenter', () => {
            $li.addClass('mn-hv').siblings().removeClass('mn-hv');
          }).find('> .mn-items').remove();
        });
        this.$mnWrap.on('mouseleave', () => {
          this.$mn.find('.mn-hv').removeClass('mn-hv');
        });
      }
    });
  }
})(jQuery)